import React from 'react'
import { MANTHLY_QQC_QUARTERLY_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyQqcQuarterlyForm from './ManthlyQqcQuarterlyForm'

export default function ManthlyQqcQuarterlyUpdate({ onCancel, onUpdate, report }) {
    const url = MANTHLY_QQC_QUARTERLY_DETAIL.replace('{id}', report.id)
    const rotationUpdate = usePutRequest({ url })

    async function onSubmit(data, actions) {
        const { success } = await rotationUpdate.request({ data })

        if (success) {
            actions.resetForm()
            onUpdate()
        }
    }

    return (
        <div>
            <b>Изменить данные о враче</b><br /><br />
            <ServerError error={rotationUpdate.error} />
            <ManthlyQqcQuarterlyForm
                initialValues={report}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={rotationUpdate.loading} />
        </div>
    )
}
